import Intro from "@/components/intro";
import { FORTINET_CONSTANTS } from "./constants";

const FortinetSdn = () => {
  return <Intro {...FORTINET_CONSTANTS} />;
};

export default FortinetSdn;
